import * as React from "react";
import { useDatasourcesContext } from "../Datasource/Context/DatasourcesContextProvider";
import { ReadOnlyFieldSchema, SelectFieldOption, SelectFieldSchema } from "../Schema/Fields";
import { getFullPropertyPath } from "../Utils/path";
import { useUnmounted } from "@cak-legacy/shared-common";

export enum LoadState {
  loading = "loading",
  loaded = "loaded",
  notLoaded = "notLoaded"
}

export interface IUseGetDatasourceOptionsResult {
  loadState: LoadState;
  options: SelectFieldOption[] | null;
}

export interface IUseGetDatasourceOptionsProps {
  getValue: (key: string) => string | null;
  setValue?: (key: string, value: any) => void;
  field: SelectFieldSchema | ReadOnlyFieldSchema;
  name: string;
}
export const useGetDatasourceOptions = (
  props: IUseGetDatasourceOptionsProps
): IUseGetDatasourceOptionsResult => {
  const [loadState, setLoadState] = React.useState<LoadState>(
    props.field.options !== undefined ? LoadState.loaded : LoadState.notLoaded
  );
  const datasources = useDatasourcesContext();
  const [options, setOptions] = React.useState<SelectFieldOption[]>(props.field.options ?? []);

  const currentValue = props.getValue(props.name);
  const { getIsUnmounted } = useUnmounted();
  //initial loading datasource
  React.useEffect(() => {
    if (props.field.datasource) {
      const datasource = datasources.find((item) => item.key === props.field.datasource?.key);
      if (datasource && !props.field.datasource.datasourceParams1) {
        setLoadState(LoadState.loading);
        datasource.fetch().then((result) => {
          if (getIsUnmounted()) return;
          setOptions([...result]);
          setLoadState(LoadState.loaded);
        });
      }
    }
  }, []);

  //datasource params
  let datasourceParamsValue1: string | null | undefined = null;
  let datasourceParamsValue2: string | null | undefined = null;

  if (props.field.datasource?.datasourceParams1) {
    datasourceParamsValue1 = props.getValue(
      getFullPropertyPath(
        `${props.name.substring(0, props.name.lastIndexOf("."))}.`,
        props.field.datasource.datasourceParams1
      )
    );
  }

  if (props.field.datasource?.datasourceParams2) {
    datasourceParamsValue2 = props.getValue(
      getFullPropertyPath(
        `${props.name.substring(0, props.name.lastIndexOf("."))}.`,
        props.field.datasource.datasourceParams2
      )
    );
  }

  if (props.field.datasource?.datasourceParams1 || props.field.datasource?.datasourceParams2) {
    React.useEffect(() => {
      if (
        datasourceParamsValue1 !== "" &&
        datasourceParamsValue1 !== undefined &&
        datasourceParamsValue1 !== null &&
        (props.field.datasource?.datasourceParams2 === undefined ||
          (props.field.datasource?.datasourceParams2 !== undefined &&
            datasourceParamsValue2 !== "" &&
            datasourceParamsValue2 !== undefined &&
            datasourceParamsValue2 !== null))
      ) {
        const datasource = datasources.find((item) => item.key === props.field.datasource?.key);
        if (datasource) {
          setLoadState(LoadState.loading);
          datasource.fetch(datasourceParamsValue1, datasourceParamsValue2).then((result) => {
            if (getIsUnmounted()) return;
            setOptions(result);
            setLoadState(LoadState.loaded);

            if (currentValue && props.setValue && !result.find((option) => option.value === currentValue)) {
              props.setValue(props.name, null);
            }
          });
        }
      } else {
        if (props.setValue) {
          props.setValue(props.name, null);
        }
      }
    }, [datasourceParamsValue1, datasourceParamsValue2]);
  }

  return {
    options,
    loadState
  };
};
